import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ENotificationBaseReportService } from '@app/shared/services/e-notification.base.service';
import { ShellService } from '@mynexus/mfe-core';
import { ProductNames } from '@mynexus/mynexus-ui-lib';

@Injectable({
  providedIn: 'root'
})
export class ENotificationPacReportService extends ENotificationBaseReportService {



  constructor(
    http: HttpClient,
    shellService: ShellService,
   ) {
    super(http, shellService, ProductNames.PACIM);
    }


}
